import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1000px;
  display: flex;
  overflow-x: auto;
  flex-direction: column;

  h1 {
    text-align: left;
    color: #000;
  }

  h3 {
    font-size: 24px;
    margin-top: 5px;
    color: #3f8600;
  }

  .title {
    width: 100%;
    margin-bottom: 13px;
    font-weight: 600;
    font-size: 14px;
    text-align: left;
    word-wrap: break-word;
    white-space: normal;
  }
`;

export const Card = styled.div`
  border-radius: 8px;
  width: 165px;
  height: 45px;
  padding: 0 25px;
  border-radius: 50px;
  margin-bottom: 15px;
  background: #008037;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 17px;
  font-family: Montserrat;
  color: #fff;
  font-weight: 600;
`;

export const Table = styled.table`
  width: 100%;
  margin-top: 25px;
  border: none;
  border-collapse: separate;
  color: #001b22;
  border-spacing: 0 1em;

  thead {
    tr {
      td {
        padding: 0 15px;
        text-align: center;

        &:last-child {
          text-align: center;
        }
      }
    }
  }

  tbody {
    tr {
      td {
        color: #001b22;
        font-size: 14px;
        height: 40px;
        padding: 0 15px;
        background: #f0f0f0;
        text-align: center;

        a {
          margin: 10px;
        }

        &:first-child {
          border-bottom-left-radius: 5px;
          border-top-left-radius: 5px;
        }

        &:last-child {
          text-align: center;
          border-bottom-right-radius: 5px;
          border-top-right-radius: 5px;
        }
      }
    }
  }
`;
